import TrackingEvent, { TrackingBrowserEventTypes } from '../../helpers/tracking-event/tracking-event'

export const getIsVisibleTrackParamsForRecommendationCarousal = ({
  trackingId,
  trackingTypes,
  tracker,
}: {
  trackingId?: string
  trackingTypes?: TrackingBrowserEventTypes[]
  tracker?: string
}) => {
  const isVisibilityTrackingEnabledFromSectionConfig =
    trackingId && (trackingTypes || []).includes(TrackingEvent.TRACKING_BROWSER_EVENT_TYPES.VISIBLE)

  if (isVisibilityTrackingEnabledFromSectionConfig || !tracker) {
    return null
  }

  return {
    action: `${tracker}__product_recommendation_carousel`,
    // @i18n-ignore
    value: 'true',
    category: 'scroll_into_view',
  }
}
